import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './styles/index.css'
import { bootMark, bootSubtotal } from './utils/bootTiming.js'

bootMark('js:main-entry')

const app = <App />;

ReactDOM.createRoot(document.getElementById('root')).render(
  import.meta.env.DEV ? <React.StrictMode>{app}</React.StrictMode> : app,
);

bootMark('react:render-called')
bootSubtotal('JS エントリ〜初回 render 呼出')
